import React, { useEffect } from "react";
import "./Hero2.css";
import useLocalStorage from "use-local-storage";

const Hero2 = () => {
  const [theme] = useLocalStorage("theme", "light");

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".hero2 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      title: "Cloud POS & ERP Systems",
      description: "Centralized inventory, real-time analytics, and multi-store management.",
      slideDir: "slide-left",
    },
    {
      title: "Web & Mobile App Design",
      description: "Fast, intuitive, and high-converting custom digital experiences.",
      slideDir: "slide-right",
    },
    {
      title: "E-Commerce Platforms",
      description: "Scalable online stores synced directly with physical inventory.",
      slideDir: "slide-left",
    },
    {
      title: "Interactive Digital Menus",
      description: "QR & tablet ordering built for modern restaurants & cafes.",
      slideDir: "slide-right",
    },
    {
      title: "Bespoke System Development",
      description: "Custom APIs, automated workflows, and enterprise-grade software.",
      slideDir: "slide-left",
    },
  ];

  return (
    <div className="hero2">
      <div className="services-header animate-side slide-left">
        <h2>OUR SERVICES</h2>
        <p className="subtitle">Building the Digital Infrastructure for Modern Commerce</p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className={`service-card animate-side ${service.slideDir}`}
          >
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero2;